import { Select } from "./ui/select";
import { Switch } from "./ui/switch";
import type { ReactNode } from "react";

export function escalationStageError(
  enabled: boolean,
  target: string | null,
  working: readonly string[],
): string | null {
  if (!enabled) return null;
  if (working.length === 0)
    return "Для передачи выберите рабочие этапы: режим «Все этапы» включает и этап менеджера.";
  if (!target) return "Выберите этап передачи менеджеру.";
  if (working.includes(target))
    return "Этап передачи должен находиться вне рабочих этапов агента.";
  return null;
}
export function EscalationSettings({
  enabled,
  target,
  working,
  stages,
  onEnabled,
  onTarget,
  disabled = false,
  showTarget = false,
  conditionsHint,
}: {
  enabled: boolean;
  target: string | null;
  working: readonly string[];
  stages: readonly { id: string; name: string }[];
  onEnabled: (value: boolean) => void;
  onTarget: (value: string | null) => void;
  disabled?: boolean;
  showTarget?: boolean;
  conditionsHint?: ReactNode;
}) {
  const error = escalationStageError(enabled, target, working);
  return (
    <fieldset
      className="space-y-3 rounded-lg border bg-card p-4"
      disabled={disabled}
    >
      <label className="flex items-center justify-between gap-4 text-sm font-medium">
        <span>Передавать менеджеру</span>
        <Switch
          aria-label="Передавать менеджеру"
          checked={enabled}
          onCheckedChange={onEnabled}
        />
      </label>
      {(enabled || showTarget) && (
        <>
          <label className="block text-sm">
            Этап передачи
            <Select
              className="mt-2"
              value={target ?? ""}
              onChange={(e) => onTarget(e.target.value || null)}
              aria-invalid={!!error}
            >
              <option value="">Выберите этап</option>
              {stages.map((stage) => (
                <option key={stage.id} value={stage.id}>
                  {stage.name}
                </option>
              ))}
            </Select>
          </label>
          <p className="text-sm text-muted-foreground">
            {conditionsHint ??
              "Условия передачи задаются в отдельном блоке промпта ниже."}
          </p>
          {error && (
            <p role="alert" className="text-sm text-destructive">
              {error}
            </p>
          )}
        </>
      )}
    </fieldset>
  );
}
